module.exports = __webpack_public_path__ + "static/fonts/iconfont.96184e6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.eot?t=1602470866315
// module id = ZIOV
// module chunks = 1